import { render, staticRenderFns } from "./OptInForm.vue?vue&type=template&id=f3c6812e&lang=pug"
import script from "./OptInForm.vue?vue&type=script&lang=js"
export * from "./OptInForm.vue?vue&type=script&lang=js"
import style0 from "./OptInForm.vue?vue&type=style&index=0&id=f3c6812e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports